import * as types from "./types";
import Routes from "./../../api/routes"; // API endpoint routes
import { get, getForSSR } from "../../api";
const { SEARCHBRANDVEHICLE } = Routes;

/******************** 
@purpose : set Home pages data
@Parameter : { data }
@Author : INIC
******************/
export const setHomePageData = (data) => {
  return {
    type: types.SET_HOME_INFO,
    data,
  };
};

/******************* 
@purpose :  get Dynamic pages data
@Parameter : {locationId,slug}
@Author : INIC
******************/
export const getDynamicPageData =
  (locationId, slug, special, authorizationToken, slugIdsQuery) =>
  (dispatch) => {
    let fullUrl = "";
    if (authorizationToken) {
      fullUrl = getForSSR(
        `dynamic-page/${slug}?location_id=${locationId}&special=${special}&${slugIdsQuery}`,
        false,
        false,
        authorizationToken
      );
    } else {
      fullUrl = get(
        `dynamic-page/${slug}?location_id=${locationId}&special=${special}&${slugIdsQuery}`,
        false
      );
    }

    return fullUrl.then((res) => {
      if (res?.data) {
        dispatch(setHomePageData(res?.data));
        return res.data;
      }
      return Promise.reject(res);
    });
  };

/******************* 
@purpose :  get brand and vehicle data using str
@Parameter : {locationId,search}
@Author : INIC
******************/
export const searchBrandVehicle = (locationId, search) => (dispatch) => {
  return get(
    `${SEARCHBRANDVEHICLE}?location_id=${locationId}&search=${search}`,
    false,
    false
  ).then((res) => {
    if (res?.data) {
      return Promise.resolve(res.data);
    }
    return Promise.reject(res);
  });
};
